import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.down('md')]: {
      order: '-1',
    },
  },
  content: {
    margin: '69px 0 0 69px',
    maxWidth: '298px',
    background: '#E8F7FE',
    borderRadius: '8px',
    padding: '16px 16px 26px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
    [theme.breakpoints.down('md')]: {
      margin: '0',
      maxWidth: 'unset',
    },
  },
  list: {
    margin: '0',
    padding: '0 0 0 18px',
  }
}))
